export const TRIAL_ENDPOINTS = {
  STATUS: '/companies/trial/status',
};

export const TRIAL_QUERY_KEYS = {
  STATUS: 'TRIAL_STATUS',
};
